<ng-container *ngIf="hospital">
	<app-hospital-patient-list 
		(onRowView)="onRowView( $event )" 
		[dataSource]="hospital" 
		(onBack)="handleBack()" 
		[statuses]="statuses"
		(onPatientAdd)="handlePatientAdd( $event )">
	</app-hospital-patient-list>
</ng-container>
